(function () {
  const stopVideo = (section) => {
    const videos = section.querySelectorAll("video");
    const buttonsPlay = section.querySelectorAll(".js-play-video-img-text");

    if (videos.length > 0) {
      videos.forEach((video) => {
        video.pause();
      });
    }

    if (buttonsPlay.length > 0) {
      buttonsPlay.forEach((btn) => {
        btn.classList.remove("active");
      });
    }
  };

  const playVideo = (section) => {
    const videos = section.querySelectorAll("video");

    if (videos.length > 0) {
      videos.forEach((video) => {
        const button = video.parentElement.querySelector(
          ".js-play-video-img-text"
        );

        if (video.parentElement.classList.contains("autoplay")) {
          video.autoplay = true;

          if (button) {
            button.classList.remove("active");
          }
        }

        if (video.autoplay && video.paused) {
          video.play();

          if (button) {
            button.classList.remove("active");
          }
        }
      });
    }
  };

  const controlsVideo = (section) => {
    const buttonsPlay = section.querySelectorAll(".js-play-video-img-text");
    const buttonsSound = section.querySelectorAll(".js-sound-video-img-text");

    buttonsPlay.forEach((button) => {
      button.onclick = () => {
        const video = button.parentElement.querySelector("video");

        if (video) {
          if (video.paused) {
            setTimeout(() => {
              video.play();
            }, 10);
          } else {
            setTimeout(() => {
              video.pause();
            }, 10);
          }

          button.classList.toggle("active");
        }
      };
    });

    buttonsSound.forEach((button) => {
      button.onclick = () => {
        const video = button.parentElement.querySelector("video");

        if (video) {
          if (video.muted) {
            setTimeout(() => {
              video.muted = false;
            }, 10);
          } else {
            setTimeout(() => {
              video.muted = true;
            }, 10);
          }
          button.classList.toggle("active");
        }
      };
    });
  };

  const initComparisonSliders = () => {
    const comparisonContainers = document.querySelectorAll(
      '[class*="image-with-text-comparison-"]'
    );

    comparisonContainers.forEach((container) => {
      const classList = container.className.split(" ");
      const sectionClass = classList.find((c) =>
        c.startsWith("image-with-text-comparison-")
      );
      const sectionId = sectionClass?.replace(
        "image-with-text-comparison-",
        ""
      );

      if (!sectionId) return;

      const afterImage = container.querySelector(
        `.image-with-text-after-${sectionId}`
      );
      const slider = container.querySelector(
        `.image-with-text-slider-${sectionId}`
      );

      if (!afterImage || !slider) return;

      let isDragging = false;
      let animationFrameId = null;
      let currentPosition = parseFloat(
        container.getAttribute("data-slider-position") || "50"
      );
      let containerRect = container.getBoundingClientRect();

      const updateRect = () => {
        containerRect = container.getBoundingClientRect();
      };

      const resizeObserver = new ResizeObserver(updateRect);
      resizeObserver.observe(container);

      const updatePosition = (clientX) => {
        const x = clientX - containerRect.left;
        currentPosition = Math.max(
          0,
          Math.min(100, (x / containerRect.width) * 100)
        );

        if (animationFrameId) {
          cancelAnimationFrame(animationFrameId);
        }

        animationFrameId = requestAnimationFrame(() => {
          afterImage.style.clipPath = `inset(0 0 0 ${currentPosition}%)`;
          slider.style.left = `${currentPosition}%`;
          container.setAttribute("data-slider-position", currentPosition);
          animationFrameId = null;
        });
      };

      const onStart = (clientX) => {
        isDragging = true;
        updateRect();
        updatePosition(clientX);
      };

      const onMove = (clientX) => {
        if (isDragging) updatePosition(clientX);
      };

      const onEnd = () => {
        isDragging = false;
      };

      container.addEventListener("mousedown", (e) => {
        e.preventDefault();
        onStart(e.clientX);
      });

      document.addEventListener("mousemove", (e) => {
        if (isDragging) onMove(e.clientX);
      });

      document.addEventListener("mouseup", onEnd);

      container.addEventListener(
        "touchstart",
        (e) => {
          e.preventDefault();
          onStart(e.touches[0].clientX);
        },
        { passive: false }
      );

      container.addEventListener(
        "touchmove",
        (e) => {
          if (isDragging) {
            e.preventDefault();
            onMove(e.touches[0].clientX);
          }
        },
        { passive: false }
      );

      document.addEventListener("touchend", onEnd);

      container.addEventListener("click", (e) => {
        updateRect();
        updatePosition(e.clientX);
      });

      afterImage.style.clipPath = `inset(0 0 0 ${currentPosition}%)`;
      slider.style.left = `${currentPosition}%`;

      container._cleanup = () => {
        resizeObserver.disconnect();
        if (animationFrameId) cancelAnimationFrame(animationFrameId);
      };
    });
  };

  const initSection = () => {
    const sections = document.querySelectorAll(".image-with-text-section");

    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) playVideo(entry.target);
        else stopVideo(entry.target);
      });
    });

    const sectionResizeObserver = new ResizeObserver((entries) => {
      const [entry] = entries;
      playVideo(entry.target);
    });

    sections.forEach((section) => {
      sectionObserver.observe(section);
      sectionResizeObserver.observe(section);
      controlsVideo(section);
    });

    initComparisonSliders();
  };

  initSection();

  document.addEventListener("shopify:section:load", function () {
    initSection();
  });
})();
